import { PaymentMethodType } from "../../Settings/components/payment/FlowAddPaymentMethod";

const SDK_ID_TO_INTERNAL: Record<string, PaymentMethodType> = {
  ach: "ach",
  credit_card: "credit"
};

export const parseAllowedPaymentMethods = (
  queryParam: string
): PaymentMethodType[] => {
  const result: PaymentMethodType[] = [];

  queryParam
    .split(",")
    .map(value => value.trim())
    .filter(Boolean)
    .forEach(value => {
      const mapped = SDK_ID_TO_INTERNAL[value];
      if (mapped && !result.includes(mapped)) {
        result.push(mapped);
      }
    });

  return result;
};
